export default __webpack_public_path__ + "static/media/hoax-right.6880cde6.png";